var f = function(r, i) {
  return i === void 0 && (i = "__TYPE"), (r == null ? void 0 : r.props) && r.props[i] || typeof (r == null ? void 0 : r.type) == "string" && r.type || (r == null ? void 0 : r.type) && typeof r.type == "symbol" && r.type.toString() === "Symbol(react.fragment)" && "react.fragment" || typeof (r == null ? void 0 : r.type) == "function" && r.type || typeof (r == null ? void 0 : r.type) == "object" && r.type.$$typeof.toString() === "Symbol(react.forward_ref)" && "react.forward_ref" || typeof r == "string" && "string" || typeof r == "function" && "function" || void 0;
};
export {
  f as typeOfComponent
};
